import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/accessibility.vue
var o = {
	name: "DtIconAccessibility",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--accessibility"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Accessibility",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M7 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-3.354.146a.5.5 0 0 1 .593-.085l2.75 1.5a.5.5 0 0 1 .168.73L6.25 5.562a2.998 2.998 0 0 1 .435.381l2.736-.438a.5.5 0 0 1 .574.565l-.5 3.5a.5.5 0 0 1-.99-.142L8.909 6.6l-1.633.261a3 3 0 0 1 .218.946c.024.383-.024.756-.139 1.108a.5.5 0 1 1-.95-.312 2 2 0 0 0-2.033-2.6h-.001a1.94 1.94 0 0 0-.717.183.5.5 0 0 1-.428-.904 3 3 0 0 1 2.112-.164l.678-.95-1.927-1.05-1.235 1.235a.5.5 0 1 1-.708-.708l1.5-1.5Zm-1.37 4.619a.5.5 0 0 1 .32.63 2 2 0 0 0 2.033 2.6 1.92 1.92 0 0 0 .717-.182.5.5 0 0 1 .428.904 3 3 0 0 1-4.268-2.525 2.953 2.953 0 0 1 .139-1.108.5.5 0 0 1 .63-.32Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=accessibility.js.map